<template>
<form :class="['search-form mini', {'is-active' : active}]" @submit.prevent="submit">
    <div class="control">
        <input type="text" class="input is-large" @blur="on_blur" v-model="term" />
    </div>
    <button class="btn-search"><i class="fas fa-search"></i></button>
</form>
</template>

<script>
export default {
    name        :   'MiniSearchform',
    data()
    {
        return {
            active  :   this.$route.query.term ? true : false,
            term    :   this.$route.query.term ? this.$route.query.term : null
        }
    },
    mounted()
    {
        this.$nextTick().then(() => {
            $(this.$el).find('.btn-search').unbind('mouseenter', this.form_activate).on('mouseenter', this.form_activate);
            $(this.$el).unbind('mouseleave', this.form_deactivate).on('mouseleave', this.form_deactivate);
        });
    },
    methods     :   {
        form_deactivate(e)
        {
            e.preventDefault();
            if (!this.term || this.term.trim().length == 0) {
                this.active =   false;
            }
        },
        on_blur(e)
        {
            if (!this.term || this.term.trim().length == 0) {
                this.active =   false;
            }
        },
        form_activate(e)
        {
            e.preventDefault();
            this.active =   true;
            let input   =   $(this.$el).find('.input');
            setTimeout(function () {
                input.focus();
            }, 300);
        },
        submit()
        {
            if (!this.term || this.term.trim().length == 0) {
                $(this.$el).find('.input').focus();
                return false;
            }

            this.$router.push({ name: 'SearchPage', query: { term: this.term, csrf: this.$store.state.site_data.session.csrf } });
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/blocks/elements/MiniSearchform.vue